import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { MAP_VIEW } from '../../brands/default/constants';
import { MAP_FILTERS } from '../../brands/default/content/components/map-view';
import ThemeContext from '../../providers/ThemeProvider';
import WowModal from '../WowModal';
import FilterMultiSelect from '../_generic/filter/FilterMultiSelect';
import RangeActionButton from '../_generic/range/RangeActionButton';
import { PriceRange } from '../filters/RangeSelector';
import MapViewBackButton from './MapViewBackButton';

const MapFilters = ({
  categoryFilters,
  isMobile,
  selectedCategories,
  setFilters,
  sliderValues,
}) => {
  const theme = useContext(ThemeContext);
  const [modalOpen, setModalOpen] = useState(false);

  const updateFilter = (config) => {
    setFilters(config);
  };

  const resetFilters = () => {
    setFilters({
      categories: [],
      sliderValues: [0, MAP_VIEW.FILTER_PRICE_MAPS.length - 1],
    });
  };

  const categoryFilter = (
    <ul className="select-menu__list">
      <FilterMultiSelect
        inline={isMobile}
        invert={false}
        isMapPage
        label={MAP_FILTERS.filterCategories}
        onChange={(value) => {
          updateFilter({
            categories: value,
            sliderValues,
          });
        }}
        options={categoryFilters}
        selected={selectedCategories}
      />
      <style jsx>{`
        .select-menu__list {
          font-size: 15px;
          list-style: none;
          padding: 0;
          margin-bottom: 0;
        }
      `}</style>
    </ul>
  );

  const priceFilter = (
    <div className="range">
      <PriceRange
        categories={selectedCategories}
        filterPrices={MAP_VIEW.FILTER_PRICE_MAPS}
        inline
        invert={!isMobile}
        sliderValues={sliderValues}
        sortBy=""
        updateFilter={updateFilter}
      />

      <style jsx>{`
        .range {
          padding: 0 40px 40px 10px;
        }
        @media only screen and (min-width: ${theme.breakpoints.smUp}) {
          .range {
            padding: 10px 40px 30px 10px;
            width: 280px;
          }
        }
      `}</style>
    </div>
  );

  if (isMobile) {
    return (
      <>
        <div className="filter-bar">
          <div className="container">
            <div className="filters">
              <button
                className="filter-button"
                id="search-button"
                onClick={() => setModalOpen((state) => !state)}
                type="button"
              >
                <FontAwesomeIcon
                  color={theme.colors.primary}
                  icon={faSlidersH}
                />
                {MAP_FILTERS.refine}
              </button>
              <MapViewBackButton />
            </div>
            <WowModal
              ariaLabelledBy="search-button"
              setShowModal={setModalOpen}
              showModal={modalOpen}
            >
              <div className="modal-padding">
                <div className="buttons">
                  <RangeActionButton onClick={resetFilters}>
                    {MAP_FILTERS.clear}
                  </RangeActionButton>
                  <RangeActionButton onClick={() => setModalOpen(false)}>
                    {MAP_FILTERS.done}
                  </RangeActionButton>
                </div>
                <h3 className="heading">{MAP_FILTERS.filterPriceShort}</h3>
                <div>{priceFilter}</div>
                <h3 className="heading">{MAP_FILTERS.filterCategories}</h3>
                <div className="modal-padding">{categoryFilter}</div>
              </div>
            </WowModal>
          </div>
        </div>
        <style jsx>{`
          .filter-bar {
            background-color: transparent;
            position: absolute;
            width: 100%;
          }
          .buttons {
            display: flex;
            justify-content: space-between;
          }
          .filter-button {
            border: 0;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
            background-color: #fff;
            padding: 5px 8px;
            border-radius: 5px;
            font-size: 1.5rem;
            margin-left: auto;
          }
          :global(.filter-button svg) {
            margin-right: 8px;
          }
          .modal-padding {
            padding: 0 10px 10px 10px;
          }
          .heading {
            color: #000;
            margin: 10px 0;
          }
          .filters {
            background-color: transparent;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0;
            position: relative;
            width: 100%;
            z-index: 1000;
          }
          @media only screen and (min-width: ${theme.breakpoints.mdUp}) {
            .filter-bar {
              background-color: ${theme.colors.primary};
            }
            .filters {
              background-color: ${theme.colors.primary};
            }
          }
        `}</style>
      </>
    );
  }

  return (
    <>
      <div className="filter-bar">
        <div className="container">
          <div className="filters">
            {categoryFilter}
            {priceFilter}
          </div>
        </div>
      </div>
      <style jsx>{`
        .filter-bar {
          background-color: ${theme.colors.primary};
        }
        .filters {
          background-color: ${theme.colors.primary};
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 20px;
          position: relative;
          width: 100%;
          z-index: 1000;
        }
      `}</style>
    </>
  );
};

MapFilters.propTypes = {
  categoryFilters: PropTypes.array,
  isMobile: PropTypes.bool,
  selectedCategories: PropTypes.array,
  setFilters: PropTypes.func,
  sliderValues: PropTypes.array,
};

export default MapFilters;
